import { useEffect, useRef } from 'react';

function useFocusRestore(open) {
  const previousFocusRef = useRef(null);

  useEffect(() => {
    if (open) {
      previousFocusRef.current = document.activeElement;
      return;
    }

    if (previousFocusRef.current && document.contains(previousFocusRef.current)) {
      previousFocusRef.current.focus();
      return;
    }

    document.body.focus();
  }, [open]);
}

export default useFocusRestore;
